import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { GetDetalleGarantiaLocatario } from '../../../../api/Api';
import GarantiaInfo from "../../../../Components/Garantias/GarantiaInfo";
import { PageTitle } from '../../../../../_metronic/layout/core';


export default function ViewGarantia(data) {
  const { id } = useParams();
  const [garantiaData, setGarantiaData] = useState(null)

  const getDetalleGarantiaLocatario = useCallback((id) => {
    GetDetalleGarantiaLocatario(id).then((response) => {
      console.info(response.data, "RESPONSE DATA");
      let nombreBanco = null;
      let urlFileNameAdjuntoExcepcion = null;
      let fileNameAdjuntoExcepcion = null;

      if (response.data.detalle_garantia.excepcion.nombre_banco_carta_fianza) {
        nombreBanco = response.data.detalle_garantia.excepcion.nombre_banco_carta_fianza;
      } else if (response.data.detalle_garantia.excepcion.nombre_banco_efectivo) {
        nombreBanco = response.data.detalle_garantia.excepcion.nombre_banco_efectivo;
      }

      if (response.data.detalle_garantia.excepcion.url_file_name_carta_fianza) {
        urlFileNameAdjuntoExcepcion = response.data.detalle_garantia.excepcion.url_file_name_carta_fianza;
        fileNameAdjuntoExcepcion = response.data.detalle_garantia.excepcion.file_name_carta_fianza;
      } else if (response.data.detalle_garantia.excepcion.url_file_name_efectivo) {
        urlFileNameAdjuntoExcepcion = response.data.detalle_garantia.excepcion.url_file_name_efectivo;
        fileNameAdjuntoExcepcion = response.data.detalle_garantia.excepcion.file_name_efectivo;
      }
      setGarantiaData({
        id_detalle_garantia: response.data.detalle_garantia.id_garantia_detalle,
        revision_locatario: response.data.detalle_garantia.revision_locatario,
        revision_cobranza: response.data.detalle_garantia.revision_cobranza,
        revision_tesoreria: response.data.detalle_garantia.revision_tesoreria,
        estado_garantia: response.data.detalle_garantia.estado,
        nro_contrato: response.data.garantia.nro_contrato,
        ruc: response.data.garantia.ruc,
        razon_social: response.data.garantia.razon_social,
        nombre_comercial: response.data.garantia.nombre_comercial,
        nombre_mall: response.data.garantia.mall.nombre,
        tipo_garantia: response.data.detalle_garantia.tipo_garantia,
        nro_carta_fianza: response.data.detalle_garantia.nro_carta_fianza,
        nro_operacion: response.data.detalle_garantia.nro_operacion,
        nombre_banco: response.data.detalle_garantia.banco.nombre,
        codigo_banco: response.data.detalle_garantia.banco.codigo,
        codigo_moneda: response.data.garantia.moneda.codigo,
        importe: response.data.detalle_garantia.importe,
        fecha_emision_carta_fianza: response.data.detalle_garantia.fecha_emision_carta_fianza,
        fecha_vencimiento_carta_fianza: response.data.detalle_garantia.fecha_vencimiento_carta_fianza,
        url_filename_operacion: response.data.detalle_garantia.url_filename_operacion,
        url_filename_carta_fianza: response.data.detalle_garantia.url_filename_carta_fianza,
        is_excepcion: response.data.detalle_garantia.is_excepcion,
        excepcion: {
          codigo_estado_excepcion: response.data.detalle_garantia.excepcion.codigo_estado_excepcion,
          codigo_tipo_excepcion: response.data.detalle_garantia.excepcion.codigo_tipo_excepcion,
          nombre_tipo_excepcion: response.data.detalle_garantia.excepcion.nombre_tipo_excepcion,
          codigo_tipo_garantia_excepcion: response.data.detalle_garantia.excepcion.codigo_tipo_garantia_excepcion,
          importe: response.data.detalle_garantia.excepcion.importe,
          codigo_moneda: response.data.detalle_garantia.excepcion.codigo_moneda,
          fecha_vencimiento: response.data.detalle_garantia.excepcion.fecha_vencimiento,
          motivo: response.data.detalle_garantia.excepcion.motivo,
          url_file_name_adjunto: response.data.detalle_garantia.excepcion.url_file_name_adjunto,
          file_name_adjunto: response.data.detalle_garantia.excepcion.file_name_adjunto,
          nro_operacion_efectivo: response.data.detalle_garantia.excepcion.nro_operacion_efectivo,
          fecha_deposito_efectivo: response.data.detalle_garantia.excepcion.fecha_deposito_efectivo,
          nro_carta_fianza: response.data.detalle_garantia.excepcion.nro_carta_fianza,
          fecha_emision_carta_fianza: response.data.detalle_garantia.excepcion.fecha_emision_carta_fianza,
          fecha_vencimiento_carta_fianza: response.data.detalle_garantia.excepcion.fecha_vencimiento_carta_fianza,
          nombre_banco: nombreBanco,
          url_file_name_adjunto_excepcion: urlFileNameAdjuntoExcepcion,
          file_name_adjunto_excepcion: fileNameAdjuntoExcepcion,
        }
      })
    })
  }, [])

  useEffect(() => {
    if (id) {
      getDetalleGarantiaLocatario(id)
    }
  }, [getDetalleGarantiaLocatario, id])


  const breadcrumbs = [
    { title: "Inicio", path: "/dashboard", isActive: true, isSeparator: false },
    { title: "", path: "", isActive: false, isSeparator: true },
    { title: "Garantías", path: "", isActive: false, isSeparator: false },
    { title: "", path: "", isActive: false, isSeparator: true },
    { title: "Revisión de Garantías", path: "/garantias/listado_garantias_revision", isActive: false, isSeparator: false },
  ];

  return (
    <>
      <PageTitle breadcrumbs={breadcrumbs}>Detalle de garantía</PageTitle>
      <div className='max-width-xl-900'>
        <GarantiaInfo garantia={garantiaData}></GarantiaInfo>
      </div>
    </>
  )
}